var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input input--email" }, [
    _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.currentValue,
          expression: "currentValue"
        }
      ],
      attrs: { type: "email", placeholder: _vm.placeholder },
      domProps: { value: _vm.currentValue },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.currentValue = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }